import Inputmask from "inputmask";

(function () {
  try {
    const tels = document.querySelectorAll('input[type="tel"]');

    const inputMask = new Inputmask("+7 (999) 999-99-99");
    tels.forEach((tel) => {
      inputMask.mask(tel);
    });
  } catch (e) {}
})();
